/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentRequestVariantId
 */
export interface AppointmentRequestVariantId {
}

/**
 * Check if a given object implements the AppointmentRequestVariantId interface.
 */
export function instanceOfAppointmentRequestVariantId(value: object): value is AppointmentRequestVariantId {
    return true;
}

export function AppointmentRequestVariantIdFromJSON(json: any): AppointmentRequestVariantId {
    return AppointmentRequestVariantIdFromJSONTyped(json, false);
}

export function AppointmentRequestVariantIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentRequestVariantId {
    return json;
}

export function AppointmentRequestVariantIdToJSON(json: any): AppointmentRequestVariantId {
    return AppointmentRequestVariantIdToJSONTyped(json, false);
}

export function AppointmentRequestVariantIdToJSONTyped(value?: AppointmentRequestVariantId | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

